import script from "./TraitRanksOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitRanksOffer.vue?vue&type=script&setup=true&lang=js"

import "./TraitRanksOffer.vue?vue&type=style&index=0&id=ba69db0c&lang=scss"

const __exports__ = script;

export default __exports__